import { Fragment } from '@tiptap/pm/model';
import { getHTMLFromFragment, Node } from '@tiptap/core';
import { elementFromString } from '../utils/dom';
import { MarkdownNodeSpec } from 'tiptap-markdown';
import { Node as ProseNode } from 'prosemirror-model';

export default Node.create({
  name: 'markdownHTMLNode',
  addStorage(): { markdown: MarkdownNodeSpec } {
    return {
      markdown: {
        serialize(state, node, parent) {
          if (this.editor.storage.markdown.options.html) {
            state.write(serializeHTML(node, parent));
          } else {
            // eslint-disable-next-line no-console
            console.warn(
              `Tiptap Markdown: "${node.type.name}" node is only available in html mode`,
            );
            state.write(`[${node.type.name}]`);
          }
          if (node.isBlock) {
            state.closeBlock(node);
          }
        },
        parse: {
          // handled by markdown-it
        },
      },
    };
  },
});

function serializeHTML(node: ProseNode, parent: ProseNode) {
  const schema = node.type.schema;
  const html = getHTMLFromFragment(Fragment.from(node), schema);

  if (
    node.isBlock &&
    (parent instanceof Fragment || parent.type.name === schema.topNodeType.name)
  ) {
    return formatBlock(html);
  }

  return html;
}

/**
 * format html block as per the commonmark spec
 */
function formatBlock(html: string) {
  const dom = elementFromString(html);
  const element = dom.firstElementChild!;

  element.innerHTML = element.innerHTML.trim() ? `\n${element.innerHTML}\n` : `\n`;

  return element.outerHTML;
}
